function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import find from 'ramda/src/find';
import pluck from 'ramda/src/pluck';
import propEq from 'ramda/src/propEq';
import __ from 'ramda/src/__';
import i18n from 'invision-core/src/components/i18n/i18n';
import MetadataActions from 'invision-core/src/components/metadata/metadata.actions';
import MetadataSelectors from 'invision-core/src/components/metadata/metadata.selectors';
import { IsDbss } from 'invision-core/src/components/session/businessunit.selectors';
import { CODES } from 'invision-core/src/components/metadata/codes/codes.constants';
import { CUSTOMER_PAGE_IDS } from 'invision-core/src/components/configurable/customercare';
import { retrieveOfferingsMetadata } from 'invision-core/src/components/metadata/offerings/offerings.actions';
import { IsOfferingMetadataLoadingSelector } from 'invision-core/src/components/metadata/offerings/offerings.selectors';
import { FeatureToggleConstants } from 'invision-core';
import { FeatureTogglesSelector } from 'invision-core/src/components/featureToggle/featureToggle.selectors';
import localeKeys from './../../../locales/keys';
import { stateGo } from 'redux-ui-router';
import { searchCustomerRemarks, setRemarkBeingEdited } from '../../../reducers/actions/customer.remarks.actions';
import { HasAdminRemarkOverwriteAccessSelector, HasSubscriberAdminAccessSelector } from '../../../reducers/selectors/permissions.selectors';
import { CurrentAccountNumberSelector, CurrentCustomerAccountingMethodSelector, CurrentCustomerIdSelector, CurrentCustomerIsExternallyManagedARSelector, CurrentCustomerSelector, IsSubscriberStateReloadRequiredSelector, RouteParams, RouteState } from '../../../reducers/selectors/customer.selectors';
import { CurrentRemarksSelector, IsFetchingRemarksSelector, IsRemarksServiceAvailableSelector } from '../../../reducers/selectors/customer.remarks.selectors';
import { OFFERING_STATUS_TYPES } from '../offerings/offerings.constants';
import { AccountsNumberSelector, ConvergentBillerAccountDetailsSelector, ConvergentBillerAccountHasBulkProducts, CurrentAccountSummarySelector, IsARCSubscriptionMgmtFeatureToggleSelector, IsCurrentAccountPostpaidSelector, IsFetchingSubscriberSummarySelector, OfferingIsOffCycleMapSelector, NumberOfAccountsSelector } from '../../../reducers/selectors/customer.convergent.biller.selectors';
import { SelectedSubscriberOfferingInstanceIdSelector } from '../../../reducers/selectors/search.subscriber.offerings.selectors';
import { IsFetchingWidgetDataSelector, IsInGracePeriodSelector, ShowAccountBalanceWidgetSelector, ShowAccountStatusWidgetSelector, ShowActiveProductsWidgetSelector, ShowDeviceFinancingWidgetSelector, ShowOfferingsWidgetSelector, ShowServicesDeprecatedWidgetSelector, ShowOfferingDeprecatedWidgetsSelector, ShowProductsWidgetSelector, ShowServicesWidgetSelector, ShowSubscriptionsWidgetSelector, ShowTreatmentWidgetSelector, VisibleWidgetsSelector } from '../../../reducers/selectors/dashboard.selectors';
import { UserSecurityAttributesSelector } from 'invision-core/src/components/session/session.selectors';
import { ActiveContentCollectionSelector, ActiveItemCountSelector, IsFetchingContentActivitySelector, HasActiveContentActivitySelector } from '../../../reducers/selectors/customer.content.activity.selectors';
import { cancelContentActivity, fetchCustomerContentActivity } from '../../../reducers/actions/customer.content.activity.actions';
import { retrieveCustomerDataForOttDashboard } from '../../../reducers/actions/ott.dashboard.actions';
import { retrieveSubscriberFinanceDetails } from '../../../reducers/actions/customer.devices.actions';
import { retrieveConvergentBillerAccountDetails, retrieveConvergentBillerSubscriberSummary } from '../../../reducers/actions/customer.convergent.biller.actions';
import { AccountStatusWidgetUIFeatureToggleSelector, ActiveProductsWidgetUIFeatureToggleSelector, ActiveSubscriptionsWidgetUIFeatureToggleSelector, CustomerActionsTemplateSelector, CustomerTemplateWidgetSelector, CustomWidgetUIFeatureToggleSelector, DashboardAccountBalanceAndTreatmentWidgetUIFeatureToggleSelector, DashboardDeviceFinancingWidgetUIFeatureToggleSelector, DashboardOpenInvoicesWidgetUIFeatureToggleSelector, DashboardRecentProductsWidgetUIFeatureToggleSelector, NoCustomWidgetsConfiguredSelector } from '../../../reducers/selectors/customer.actions.template.selectors';
import { FormattedInteractionsSelector } from '../../../reducers/selectors/customer.interactions.selectors';
import { fetchInteractions } from '../../../reducers/actions/customer.interaction.actions';
import { NOTIFICATION_TIME_LENGTH } from '../../../customercare.constants';
import { IsCustomerWrapUpRequiredSelector } from '../../../reducers/selectors/search.selectors';
import { retrieveCustomer, retrieveSubscriberOfferingDetail, setReloadSubscriberStateFlag } from '../../../reducers/actions/customer.actions';
import { MetadataCodeLoadedSelector } from 'invision-core/src/components/metadata/codes/codes.selectors';
import { getStandaloneProduct, searchSubscriberOfferings } from '../../../reducers/actions/offering.order.actions';
import { retrieveServiceDetails, searchServices } from '../../../reducers/actions/services.actions';
import { SelectedServiceIdentifierSelector } from '../../../reducers/selectors/selected.service.details.selectors';
import { NUMBER_OF_CAROUSEL_ITEMS_TO_FETCH } from './dbssDashboard/servicesAndOffers/services.and.offers.contants';
import { TYPE_OF_SERVICE } from '../servicesAndUsage/servicesAndSharedEntitlements/services/services.list.constants';
import { ACCOUNTING_METHODS_NAMES } from '../makePayment/make.payment.constants';
import { IsAutoPayEnabledSelector } from '../../../reducers/selectors/autopay.configuration.selectors';
var DashboardController = /*#__PURE__*/function () {
  function DashboardController($ngRedux, uiNotificationService, $timeout) {
    _classCallCheck(this, DashboardController);
    Object.assign(this, {
      $ngRedux: $ngRedux,
      $timeout: $timeout,
      ACCOUNTING_METHODS_NAMES: ACCOUNTING_METHODS_NAMES,
      caseModalConfigApi: null,
      depositsModalConfigApi: null,
      disconnectRedux: null,
      editRemark: this.editRemark.bind(this),
      isPaymentFailureNotificationClosed: false,
      isTabActive: this.isTabActive.bind(this),
      getWidgetToDisplay: this.getWidgetToDisplay.bind(this),
      onAccountSelect: this.onAccountSelect.bind(this),
      isContentActivityAvailable: this.isContentActivityAvailable.bind(this),
      refreshActiveCount: this.refreshActiveCount.bind(this),
      refreshRemarks: this.refreshRemarks.bind(this),
      offeringMetadataLoaded: false,
      retrieveConvergentBillerAndDeviceFinancingDetails: this.retrieveConvergentBillerAndDeviceFinancingDetails.bind(this),
      tabSelected: this.tabSelected.bind(this),
      uiNotificationService: uiNotificationService
    });
  }
  return _createClass(DashboardController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      var codeTables = [CODES.FeatureToggleConfig, CODES.OneTimeBillerRuleConfiguration, CODES.RecurringBillerRuleConfiguration, CODES.RegularExpression, CODES.ServiceAttribute, CODES.SubscriberSearchConfig];
      var mapStateToTarget = function mapStateToTarget(store) {
        return {
          accountNumbers: AccountsNumberSelector(store),
          activeItemCount: ActiveItemCountSelector(store),
          businessUnitIsDbss: IsDbss(store),
          codeTypeLoaded: MetadataCodeLoadedSelector(__, store),
          currentAccountDetails: ConvergentBillerAccountDetailsSelector(store),
          currentAccountNumber: CurrentAccountNumberSelector(store),
          currentAccountSummary: CurrentAccountSummarySelector(store),
          currentCustomer: CurrentCustomerSelector(store),
          currentCustomerAccountingMethod: CurrentCustomerAccountingMethodSelector(store),
          currentCustomerActiveContent: ActiveContentCollectionSelector(store),
          currentCustomerId: CurrentCustomerIdSelector(store),
          currentCustomerInteractions: FormattedInteractionsSelector(store),
          currentCustomerIsExternallyManagedAR: CurrentCustomerIsExternallyManagedARSelector(store),
          currentCustomerRemarks: CurrentRemarksSelector(store),
          currentRoute: RouteState(store),
          customerActionsTemplate: CustomerActionsTemplateSelector(store),
          customerTemplateWidgets: CustomerTemplateWidgetSelector(store),
          depositTypes: MetadataSelectors.codes.MetadataCodeTypeIntegerSelector(CODES.DepositType, store),
          depositTypesLoaded: MetadataCodeLoadedSelector(CODES.DepositType, store),
          features: FeatureTogglesSelector(store),
          hasActiveContent: HasActiveContentActivitySelector(store),
          hasAdminRemarkOverwriteAccess: HasAdminRemarkOverwriteAccessSelector(store),
          hasBulkProducts: ConvergentBillerAccountHasBulkProducts(store),
          hasSubscriberAdminAccess: HasSubscriberAdminAccessSelector(store),
          interactionTypes: MetadataSelectors.codes.MetadataCodeTypeIntegerSelector(CODES.InteractionType, store),
          interactionTypesLoaded: MetadataCodeLoadedSelector(CODES.InteractionType, store),
          isAccountStatusWidgetEnabled: AccountStatusWidgetUIFeatureToggleSelector(store),
          isActiveProductsWidgetEnabled: ActiveProductsWidgetUIFeatureToggleSelector(store),
          isActiveSubscriptionsWidgetEnabled: ActiveSubscriptionsWidgetUIFeatureToggleSelector(store),
          isARCSubscriptionMgmtFeatureLoaded: MetadataCodeLoadedSelector(CODES.MicroserviceConfiguration, store),
          isARCSubscriptionMgmtFeatureToggle: IsARCSubscriptionMgmtFeatureToggleSelector(store),
          isBusinessUnitTemplateLoaded: MetadataCodeLoadedSelector(CODES.BusinessUnitTemplate, store),
          isCurrentAccountPostpaid: IsCurrentAccountPostpaidSelector(store),
          isCustomWidgetEnabled: CustomWidgetUIFeatureToggleSelector(store),
          isCustomerWrapUpRequired: IsCustomerWrapUpRequiredSelector(store),
          isDashboardOpenInvoicesWidgetUIFeatureEnabled: DashboardOpenInvoicesWidgetUIFeatureToggleSelector(store),
          isDashboardDeviceFinancingWidgetUIFeatureEnabled: DashboardDeviceFinancingWidgetUIFeatureToggleSelector(store),
          isDashboardAccountBalanceAndTreatmentWidgetEnabled: DashboardAccountBalanceAndTreatmentWidgetUIFeatureToggleSelector(store),
          isDashboardRecentProductsWidgetEnabled: DashboardRecentProductsWidgetUIFeatureToggleSelector(store),
          isFetchingAccountSummary: IsFetchingSubscriberSummarySelector(store),
          isFetchingActiveContent: IsFetchingContentActivitySelector(store),
          isFetchingRemarks: IsFetchingRemarksSelector(store),
          isFetchingWidgetData: IsFetchingWidgetDataSelector(store),
          isInGracePeriod: IsInGracePeriodSelector(store),
          isOfferingMetadataLoading: IsOfferingMetadataLoadingSelector(store),
          isRemarksServiceAvailable: IsRemarksServiceAvailableSelector(store),
          isSubscriberStateReloadRequired: IsSubscriberStateReloadRequiredSelector(store),
          noCustomWidgetsConfigured: NoCustomWidgetsConfiguredSelector(store),
          numberOfAccounts: NumberOfAccountsSelector(store),
          offeringIsOffCycleMap: OfferingIsOffCycleMapSelector(store),
          routeParams: RouteParams(store),
          selectedOfferingInstanceId: SelectedSubscriberOfferingInstanceIdSelector(store),
          selectedServiceIdentifier: SelectedServiceIdentifierSelector(store),
          showAccountBalanceWidget: ShowAccountBalanceWidgetSelector(store),
          showAccountStatusWidget: ShowAccountStatusWidgetSelector(store),
          showActiveProductsWidget: ShowActiveProductsWidgetSelector(store),
          showAutoPay: IsAutoPayEnabledSelector(store),
          showDeviceFinancingWidget: ShowDeviceFinancingWidgetSelector(store),
          showOfferingsWidget: ShowOfferingsWidgetSelector(store),
          showServicesWidget: ShowServicesWidgetSelector(store),
          showOfferingDeprecatedWidgets: ShowOfferingDeprecatedWidgetsSelector(store),
          showProductsWidget: ShowProductsWidgetSelector(store),
          showServicesDeprecatedWidget: ShowServicesDeprecatedWidgetSelector(store),
          showSubscriptionsWidget: ShowSubscriptionsWidgetSelector(store),
          showTreatmentWidget: ShowTreatmentWidgetSelector(store),
          transitionConfigurationLoaded: MetadataCodeLoadedSelector(CODES.TransitionConfiguration, store),
          userSecurityAttributes: UserSecurityAttributesSelector(store),
          visibleCustomerTemplateWidgets: VisibleWidgetsSelector(store)
        };
      };
      this.customerCareKeys = localeKeys;
      var controllerActions = {
        cancelContentActivity: cancelContentActivity,
        fetchCodeTypes: MetadataActions.codes.fetchCodeTypes,
        fetchCustomerContentActivity: fetchCustomerContentActivity,
        fetchInteractions: fetchInteractions,
        getStandaloneProduct: getStandaloneProduct,
        retrieveConvergentBillerAccountDetails: retrieveConvergentBillerAccountDetails,
        retrieveConvergentBillerSubscriberSummary: retrieveConvergentBillerSubscriberSummary,
        retrieveCustomerDataForOttDashboard: retrieveCustomerDataForOttDashboard,
        retrieveCustomer: retrieveCustomer,
        retrieveOfferingsMetadata: retrieveOfferingsMetadata,
        retrieveServiceDetails: retrieveServiceDetails,
        retrieveSubscriberFinanceDetails: retrieveSubscriberFinanceDetails,
        retrieveSubscriberOfferingDetail: retrieveSubscriberOfferingDetail,
        searchCustomerRemarks: searchCustomerRemarks,
        searchServices: searchServices,
        searchSubscriberOfferings: searchSubscriberOfferings,
        setReloadSubscriberStateFlag: setReloadSubscriberStateFlag,
        setRemarkBeingEdited: setRemarkBeingEdited,
        stateGo: stateGo
      };
      this.disconnectRedux = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
      this.stateOrName = this.state.currentRoute;
      this.optionalParams = {
        customerId: this.state.currentCustomerId
      };
      codeTables.forEach(function (codeType) {
        if (!_this.state.codeTypeLoaded(codeType)) {
          _this.actions.fetchCodeTypes(codeType).catch(function (error) {
            _this.uiNotificationService.transientError(error.translatedMessage);
          });
        }
      });
      if (this.state.currentCustomerId) {
        if (!this.state.transitionConfigurationLoaded) {
          this.actions.fetchCodeTypes(CODES.TransitionConfiguration);
        }
        if (!this.state.isARCSubscriptionMgmtFeatureLoaded) {
          this.actions.fetchCodeTypes(CODES.MicroserviceConfiguration);
        }
        this.actions.retrieveCustomerDataForOttDashboard(this.state.currentCustomerId);
        this.actions.fetchInteractions({
          customerId: this.state.currentCustomerId,
          PageSize: 10,
          SearchBySubscriber: true
        });
        if (this.state.businessUnitIsDbss) {
          this.actions.fetchCodeTypes(CODES.FeatureToggleConfig).then(function () {
            _this.retrieveConvergentBillerAndDeviceFinancingDetails().then(function () {
              var offeringIds = pluck('OfferingId', _this.state.currentAccountDetails.offerings);
              return _this.actions.retrieveOfferingsMetadata(offeringIds).then(function () {
                _this.offeringMetadataLoaded = true;
              });
            }).catch(function (error) {
              _this.uiNotificationService.transientError(error.translatedMessage);
            });
          });
        }
      }
      if (this.state.currentCustomer.ConvergentBillerId && !this.state.isFetchingAccountSummary) {
        this.actions.retrieveConvergentBillerSubscriberSummary(this.state.currentCustomerId, true);
      }

      // CodeType InteractionType is a required sequential fetch inside retrieveCustomerDataForOttDashboard. This prevents an unnecessary fetch.
      if (!this.state.interactionTypesLoaded && !this.state.currentCustomerId) {
        this.actions.fetchCodeTypes(CODES.InteractionType);
      }
      if (!this.state.depositTypesLoaded) {
        this.actions.fetchCodeTypes(CODES.DepositType);
      }
      if (!this.state.isBusinessUnitTemplateLoaded) {
        this.actions.fetchCodeTypes(CODES.BusinessUnitTemplate).then(function () {
          _this.isContentActivityAvailable();
        });
      }
      this.createRemarkConfig = {
        onRegisterApi: function onRegisterApi(_ref) {
          var open = _ref.api.open;
          _this.openCreateRemarkPopup = open;
        }
      };
      this.terminateStreamPopupOption = {
        onRegisterApi: function onRegisterApi(evt) {
          _this.terminateStreamPopupApi = evt.api;
        }
      };
      this.removeDownloadPopupOption = {
        onRegisterApi: function onRegisterApi(evt) {
          _this.removeDownloadPopupApi = evt.api;
        }
      };
      this.tabPanelShouldOpen = false;
      this.remarksAndActivityTabs = [{
        id: 0,
        glyph: 'align-left',
        active: false
      }, {
        id: 1,
        glyph: 'comment',
        active: false,
        notificationCount: null
      }];
      if (!this.state.isFetchingRemarks && this.state.isRemarksServiceAvailable) {
        this.refreshRemarks();
      }
      if (this.state.isSubscriberStateReloadRequired) {
        this.$timeout(function () {
          _this.actions.retrieveCustomer(_this.state.currentCustomerId);
        });
      }
      this.isContentActivityAvailable();
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.disconnectRedux();
    }
  }, {
    key: "closePaymentFailedNotification",
    value: function closePaymentFailedNotification() {
      this.isPaymentFailureNotificationClosed = true;
    }
  }, {
    key: "isContentActivityAvailable",
    value: function isContentActivityAvailable() {
      this.isContentActivityEnabled = this.state.customerActionsTemplate.pages.find(function (page) {
        if (page.id === CUSTOMER_PAGE_IDS.ACTIVITY) {
          return page.subNavigation.find(function (item) {
            return item.id === CUSTOMER_PAGE_IDS.CONTENT_ACTIVITY;
          });
        }
      });
      if (!this.state.businessUnitIsDbss && this.state.isBusinessUnitTemplateLoaded && this.isContentActivityEnabled) {
        var contentActivityTab = this.remarksAndActivityTabs.find(function (item) {
          return item.id === 2;
        });
        if (!contentActivityTab) {
          this.fetchCustomerContentActivity();
          this.remarksAndActivityTabs.push({
            id: 2,
            glyph: 'clock-o',
            active: false,
            hasEmphasis: true,
            notificationCount: this.state.activeItemCount
          });
        }
      }
    }
  }, {
    key: "getWidgetToDisplay",
    value: function getWidgetToDisplay(widget) {
      if (widget.displayServices) {
        return this.state.showServicesWidget;
      } else if (widget.displayOfferings) {
        return this.state.showOfferingsWidget;
      } else {
        return widget.displayServicesAndOfferingsWidget;
      }
    }

    // right tab column
  }, {
    key: "isTabActive",
    value: function isTabActive(tabIndex) {
      return this.remarksAndActivityTabs.some(function (tab) {
        return tab.id === tabIndex && tab.active;
      });
    }
  }, {
    key: "tabSelected",
    value: function tabSelected(_tabSelected) {
      var _this2 = this;
      this.remarksAndActivityTabs.forEach(function (tab) {
        if (tab.id === _tabSelected.id) {
          _this2.tabPanelShouldOpen = tab.active ? !_this2.tabPanelShouldOpen : true;
          tab.active = !tab.active;
        } else {
          tab.active = false;
        }
      });
    }
  }, {
    key: "refreshActiveCount",
    value: function refreshActiveCount() {
      var tab = find(propEq(2, 'id'))(this.remarksAndActivityTabs);
      if (tab) {
        tab.notificationCount = this.state.activeItemCount;
      }
    }
  }, {
    key: "refreshRemarks",
    value: function refreshRemarks() {
      var _this3 = this;
      var remarksTab = find(propEq(1, 'id'))(this.remarksAndActivityTabs);
      this.actions.searchCustomerRemarks(this.state.currentCustomerId).then(function () {
        if (remarksTab) {
          remarksTab.notificationCount = _this3.state.currentCustomerRemarks.length;
        }
      }, function () {
        if (remarksTab) {
          remarksTab.notificationCount = null;
        }
      });
    }
  }, {
    key: "retrieveConvergentBillerAndDeviceFinancingDetails",
    value: function retrieveConvergentBillerAndDeviceFinancingDetails() {
      var _this4 = this;
      var promises = [];
      promises.push(this.actions.retrieveConvergentBillerAccountDetails(this.state.currentCustomerId).then(function () {
        var productMetadataPromises = [];
        (_this4.state.currentAccountDetails.standalones || []).forEach(function (standalone) {
          productMetadataPromises.push(_this4.actions.getStandaloneProduct(standalone.ProductId));
        });
        Promise.all(productMetadataPromises);
      }));
      if (this.state.currentCustomer.ConvergentBillerId && !this.state.features[FeatureToggleConstants.OFFCYCLE_BYPASS_ARM]) {
        promises.push(this.actions.retrieveSubscriberFinanceDetails(this.state.currentCustomerId));
      }
      return Promise.all(promises);
    }
  }, {
    key: "onAccountSelect",
    value: function onAccountSelect(account) {
      this.actions.stateGo('index.customercare.customer.accountDashboard', {
        accountNumber: account.number
      });
    }
  }, {
    key: "editRemark",
    value: function editRemark(remark) {
      this.openCreateRemarkPopup();
      this.actions.setRemarkBeingEdited(remark);
    }
  }, {
    key: "onConfigureAutoPayBtnClicked",
    value: function onConfigureAutoPayBtnClicked() {
      this.actions.stateGo('index.customercare.customer.autoPay', {
        accountNumber: this.state.currentAccountNumber
      });
    }
  }, {
    key: "fetchCustomerContentActivity",
    value: function fetchCustomerContentActivity() {
      var _this5 = this;
      this.actions.fetchCustomerContentActivity(this.state.currentCustomerId, {
        IncludeDownloads: false,
        PageSize: 1 // Workaround to *not* fetch Archived Activity. We'd prefer 0, but minimum is 1
      }).then(function () {
        _this5.refreshActiveCount();
      });
    }
  }, {
    key: "handleToggleNavigatorCollapsedSelected",
    value: function handleToggleNavigatorCollapsedSelected() {
      this.actions.toggleCollapsedSelected();
    }

    // dialog methods
  }, {
    key: "openDialog",
    value: function openDialog(contentActivity) {
      this.contentActivityToTerminate = contentActivity;
      return this.contentActivityToTerminate.Download ? this.removeDownloadPopupApi.open() : this.terminateStreamPopupApi.open();
    }

    // Download dialog.
  }, {
    key: "closeRemoveDownloadDialog",
    value: function closeRemoveDownloadDialog() {
      this.removeDownloadPopupApi.close();
    }
  }, {
    key: "removeDownloadDialogResult",
    value: function removeDownloadDialogResult(remove) {
      if (remove) {
        this.terminateContentActivity(this.contentActivityToTerminate);
      }
      this.contentActivityToTerminate = null;
      this.closeRemoveDownloadDialog();
    }

    // Terminate Stream dialog.
  }, {
    key: "closeTerminateStreamDialog",
    value: function closeTerminateStreamDialog() {
      this.terminateStreamPopupApi.close();
    }
  }, {
    key: "terminateContentActivity",
    value: function terminateContentActivity(content) {
      var _this6 = this;
      var params = {
        Reference: content.Reference,
        PricingPlanId: content.PricingPlanId
      };
      this.actions.cancelContentActivity(this.state.currentCustomerId, params).then(function () {
        var localeToUse = content.Download ? _this6.customerCareKeys.CONTENT_ACTIVITY.CANCEL_DOWNLOAD.TERMINATED : _this6.customerCareKeys.CONTENT_ACTIVITY.CANCEL_STREAM.TERMINATED;
        return _this6.uiNotificationService.success(i18n.translate(localeToUse), null, {
          timeOut: NOTIFICATION_TIME_LENGTH
        });
      }).then(function () {
        _this6.fetchCustomerContentActivity();
      }).catch(function () {
        _this6.uiNotificationService.error(_this6.state.errorMessage, null, {
          timeOut: NOTIFICATION_TIME_LENGTH
        });
      });
    }
  }, {
    key: "terminateStreamDialogResult",
    value: function terminateStreamDialogResult(shouldTerminateStream) {
      if (shouldTerminateStream) {
        this.terminateContentActivity(this.contentActivityToTerminate);
      }
      this.contentActivityToTerminate = null;
      this.closeTerminateStreamDialog();
    }
  }, {
    key: "refreshConvergentBillerDetails",
    value: function refreshConvergentBillerDetails() {
      this.retrieveConvergentBillerAndDeviceFinancingDetails();
      this.actions.retrieveConvergentBillerSubscriberSummary(this.state.currentCustomerId, true);
    }
  }, {
    key: "refreshServices",
    value: function refreshServices() {
      var _this7 = this;
      var params = Object.assign({}, this.state.routeParams, {
        serviceType: TYPE_OF_SERVICE.NON_BULK,
        pageNumber: 1,
        pageSize: NUMBER_OF_CAROUSEL_ITEMS_TO_FETCH
      });
      this.actions.searchServices(params).catch(function (error) {
        _this7.uiNotificationService.transientError(error.translatedMessage);
      });
      if (this.state.selectedServiceIdentifier) {
        var serviceIdentifiers = [{
          Value: this.state.selectedServiceIdentifier
        }];
        this.actions.retrieveServiceDetails(this.state.currentCustomerId, serviceIdentifiers).catch(function (error) {
          _this7.uiNotificationService.transientError(error.translatedMessage);
        });
      }
    }
  }, {
    key: "refreshOfferings",
    value: function refreshOfferings() {
      var _this8 = this,
        _this$state$offeringI;
      var params = Object.assign({}, this.state.routeParams, {
        includeOfferingTotals: true,
        pageNumber: 1,
        pageSize: NUMBER_OF_CAROUSEL_ITEMS_TO_FETCH,
        status: [OFFERING_STATUS_TYPES.ACTIVE, OFFERING_STATUS_TYPES.PENDING_ACTIVE, OFFERING_STATUS_TYPES.PENDING_REMOVED, OFFERING_STATUS_TYPES.SUSPENDED, OFFERING_STATUS_TYPES.SUSPENSION_SCHEDULED]
      });
      this.actions.searchSubscriberOfferings(params).catch(function (error) {
        _this8.uiNotificationService.transientError(error.translatedMessage);
      });
      this.actions.retrieveSubscriberOfferingDetail(this.state.currentCustomerId, this.state.selectedOfferingInstanceId, (_this$state$offeringI = this.state.offeringIsOffCycleMap) === null || _this$state$offeringI === void 0 ? void 0 : _this$state$offeringI[this.state.selectedOfferingInstanceId]).catch(function (error) {
        _this8.uiNotificationService.transientError(error.translatedMessage);
      });
    }
  }]);
}();
export default {
  template: require('./dashboard.html'),
  require: {
    customerCtrl: '^customer'
  },
  bindings: {},
  controller: DashboardController,
  controllerAs: 'DashboardController'
};